import { toaster } from '@/components/ui/toast'
import { userId } from '@state/auth'
import { useMutation, useQuery } from '@tanstack/solid-query'
import { queryClient } from 'src/App'
import { deleteGoWatchVideo, getGoWatchVideos } from './api'

export function useGoWatch() {
	const videosQuery = useQuery(() => ({
		queryKey: ['go-watch-videos', userId()],
		queryFn: getGoWatchVideos,
		enabled: !!userId(),
	}))

	const deleteMutation = useMutation(() => ({
		mutationFn: deleteGoWatchVideo,
		onSuccess: () => {
			toaster.create({
				title: 'Video deleted',
				type: 'success',
			})
			queryClient.invalidateQueries({ queryKey: ['go-watch-videos', userId()] })
		},
		onError: (error: Error) => {
			toaster.create({
				title: 'Error deleting video',
				description: error.message,
				type: 'error',
			})
		},
	}))

	return {
		videosQuery,
		videos: () => videosQuery.data ?? [],
		deleteVideo: (id: string) => deleteMutation.mutateAsync(id),
		isDeleting: deleteMutation.isPending,
	}
}
